import { PushpinOutlined } from '@ant-design/icons';
import { RequiredRule } from '@framework/engine/schema/rules/repository/required/Required.rule.ts';
import { tran } from '@framework/engine/schema/translations/schema/TranslationSchema.ts';
import { type IWidgetType } from '@framework/engine/schema/widgets/IWidgetType.ts';
import {
  WidgetCategory,
  WidgetMainType,
} from '@framework/engine/schema/widgets/Widget.ts';
import { createMapSchema } from './createMapSchema.ts';
import { type IMapWidget, WidgetTypeMap } from './IMapWidget.ts';
import { MapWidgetComponent } from './MapWidgetComponent.tsx';
import { MapWidgetConfigComponent } from './MapWidgetConfigComponent.tsx';
import { MapWidgetConfigSchema } from './MapWidgetConfigSchema.ts';
import {
  getMapWidgetReferences,
  getMapWidgetSiblingReferences,
} from './references/getMapWidgetReferences.ts';
import { MapCalculationUpToDateRule } from './rules/MapCalculationUpToDate.rule.ts';

/**
 * Widget di tipo mappa per la selezione geolocalizzata.
 */
export const MapWidgetType: IWidgetType<IMapWidget> = {
  type: WidgetTypeMap,
  mainType: WidgetMainType.Input,
  category: WidgetCategory.Advanced,
  name: 'Mappa',
  icon: <PushpinOutlined />,
  hasValue: true,
  getReference: getMapWidgetReferences,
  getSiblingReferences: getMapWidgetSiblingReferences,
  formComponent: MapWidgetComponent,
  createFormSchema: createMapSchema,
  previewComponent: MapWidgetComponent,
  configComponent: MapWidgetConfigComponent,
  configValidator: MapWidgetConfigSchema,
  translationSchema: tran.widget({
    intersection: tran.object({
      title: tran.string(),
    }),
  }),
  rules: [RequiredRule],
  fixedRules: [MapCalculationUpToDateRule],
};
